import React from "react";
import {
  RotaTable,
  THead,
  TrHead,
  TBody,
  Th,
  Tr,
  Td,
  InnerCell,
  RotaButtonIcon,
  iconNew
} from "@teamrota/rota-design";

import { EmptyText } from "~/src/components/payroll/style";
import { PayrollScale } from "./types";
import { formatDateFull } from "~/src/utils/formatting";

const { Edit, Info } = iconNew;

type TableProps = {
  payrollScales: PayrollScale[];
  handleOpenScale: (id: string) => void;
  canEdit: boolean;
};

const Table = ({ payrollScales, handleOpenScale, canEdit }: TableProps) => {
  return (
    <RotaTable>
      <THead>
        <TrHead>
          <Th>Name</Th>
          <Th>User</Th>
          <Th>Created at</Th>
          <Th>Last edited</Th>
          <Th>Action</Th>
        </TrHead>
      </THead>

      <TBody>
        {payrollScales?.length ? (
          payrollScales.map((scale: PayrollScale) => (
            <Tr key={scale.id}>
              <Td>
                <InnerCell>{scale.name}</InnerCell>
              </Td>
              <Td>
                <InnerCell>USER</InnerCell>
              </Td>
              <Td>
                <InnerCell>{formatDateFull(scale.createdAt)}</InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  {scale.updatedAt && formatDateFull(scale.updatedAt)}
                </InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  <RotaButtonIcon
                    onClick={() => handleOpenScale(scale.id)}
                    style={{ margin: "auto" }}
                  >
                    {canEdit ? <Edit /> : <Info />}
                  </RotaButtonIcon>
                </InnerCell>
              </Td>
            </Tr>
          ))
        ) : (
          <Tr>
            <Td colSpan={5}>
              <EmptyText>Nothing to see here 👀 Try clicking Create!</EmptyText>
            </Td>
          </Tr>
        )}
      </TBody>
    </RotaTable>
  );
};

export default Table;
